var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{class:_vm.b('icon')},[_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))])],1),_c('div',{class:_vm.b('body')},[_c('div',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.title))]),_c('div',{class:_vm.b('description')},[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }